import { __extends } from "tslib";
import { ImageTexture2D } from '@awayjs/renderer';
var VideoTexture = /** @class */ (function (_super) {
    __extends(VideoTexture, _super);
    function VideoTexture() {
        return _super.call(this) || this;
    }
    Object.defineProperty(VideoTexture.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return VideoTexture.assetType;
        },
        enumerable: true,
        configurable: true
    });
    VideoTexture.assetType = '[texture VideoTexture]';
    return VideoTexture;
}(ImageTexture2D));
export { VideoTexture };
